angular.module('bmsApp.crm.customer')
	.controller('RepeatEnquiryModalCtrl', RepeatEnquiryModalCtrl);

RepeatEnquiryModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'CustomerSvc',
	'$modalInstance',
	'customer',
	'ConfigService',
	'notify',
];

function RepeatEnquiryModalCtrl($scope, $state, $q, CustomerSvc, $modalInstance, customer, ConfigService, notify) {
	let self = this;
	let handlers = {};


	angular.extend(self, {
		loading: null,
		processing: false,
		form: {},
		handlers: handlers,
		formvalidatorconfig: {
			submitHandler: function () {
				self.handlers.submit();
			},
			errorPlacement: function (error) {
				error.appendTo('#contact-errors');
			},
			errorContainer: '#contact-errors'
		}
	});

	self.handlers.init = () => {
		self.dateConfig = angular.copy(ConfigService.config.datePicker.basic);
		self.dateConfig.options.parentEl = '.modal-body';

		self.customer = customer;
		angular.extend(self.form, {
			customerId: self.customer.id,
		});
		self.loading = false;
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.cancelClick = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.submit = function () {
		return CustomerSvc.repeatEnquiry(self.form).then((response) => {
			notify({
				message: 'Successfully logged repeat enquiry',
			});
			$modalInstance.dismiss('cancel');
		});
	};
}